module.exports = __webpack_public_path__ + "static/assets/563be8887ff41c91715d4d289a1ce9ae.svg";